import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'
import MedshrTeam from '../../components/Team/container/MedshrTeam'
import Team from '../../components/Team/container/TeamPage'

const TeamPage = ({ id }: { id: string }): any => {
  const teamName =
    id === 'clinical-leaders'
      ? 'editors'
      : id === 'student-ambassadors'
      ? 'students'
      : id
  return (
    <Team teamName={teamName}>
      <MedshrTeam teamName={teamName} />
    </Team>
  )
}

export const getServerSideProps = async ({ locale, params }) => {
  return {
    props: {
      ...params,
      ...(await serverSideTranslations(locale, ['common', 'teampage'])),
    },
  }
}

export default TeamPage
